import {SuccessfulApiResponse} from "@eryxcoop/appyx-comm";
import DateAdapter from "../../adapters/DateAdapter";

export default class AuthorizationResponse extends SuccessfulApiResponse {
    static defaultResponse() {
        return {
            object: {
                'authorization': {
                    "action_request": {
                        'name': 'Free Order Confirmation Request',
                        "timestamp": "2025-10-12 12:00:00",
                        "requester": "lcuadrado@eryx.co",
                        'object_with_action_requested': "",
                    },
                    "state": "open",
                    "observations": " ",
                    "response_timestamp": "2025-10-12 13:00:00"
                }
            },
            errors: []
        }
    }

    getAuthorization() {
        const authorization = this.content()
        return {
            id: authorization.id,
            actionRequest: {
                name: this._adaptActionName(authorization),
                requester: authorization.action_request.requester,
                timestamp: DateAdapter.adaptDatetime(authorization.action_request.timestamp),
                objectWithActionRequested: this._adaptObjectWithActionRequested(authorization)
            },
            state: authorization.state,
            responseTimestamp: this._adaptDateOfApproval(authorization.response_timestamp),
            authorizator: this._adaptAuthorizator(authorization.authorizator),
            observations: authorization.observations
        }
    }

    _adaptDateOfApproval(dateOfApproval) {
        if (dateOfApproval === null) {
            return '-';
        } else {
            return dateOfApproval
        }
    }

    _adaptAuthorizator(authorizator) {
        if (authorizator === null) {
            return '-';
        }
        return authorizator;
    }

    _adaptActionName(authorization) {
        if (authorization.action_request.name === 'Free Order Confirmation Request') {
            return "Pedido Sin Cargo";
        } else if (authorization.action_request.name === 'Customer Onboarding Logistics Closing Request') {
            return "Alta de Cliente - Logística";
        } else if (authorization.action_request.name === 'Customer Onboarding Commercial Closing Request') {
            return "Alta de Cliente - Comercial";
        } else if (authorization.action_request.name === 'Customer Onboarding Finance Closing Request') {
            return "Alta de Cliente - Finanzas";
        } else if (authorization.action_request.name === 'Customer Onboarding Tax Closing Request') {
            return "Alta de Cliente - Impuestos";
        } else if (authorization.action_request.name === 'Advance Payment Request') {
            return "Pedido Con Pago Anticipado"
        } else if (authorization.action_request.name === 'Delivery Site Onboarding Tax Closing Request') {
            return "Alta de Punto de Entrega - Impuestos"
        } else if (authorization.action_request.name === 'Delivery Site Onboarding Logistics Closing Request') {
            return "Alta de Punto de Entrega - Logística"
        } else if (authorization.action_request.name === 'Allowance Confirmation Request') {
            return "Bonificación";
        } else if (authorization.action_request.name === 'Judicial Management Request') {
            return "Pase a Gestión Judicial";
        }
        return "Desconocido";
    }


    _adaptObjectWithActionRequested(authorization) {
        const action = authorization.action_request.object_with_action_requested
        if (authorization.action_request.name === 'Free Order Confirmation Request') {
            return this._adaptFreeOrderConfirmationRequest(action);
        } else if (authorization.action_request.name === 'Advance Payment Request') {
            return this._adaptAdvancePaymentRequest(action)
        } else if (authorization.action_request.name.includes('Customer Onboarding')) {
            return this._adaptCustomerOnboardingRequest(action);
        } else if (authorization.action_request.name.includes('Delivery Site Onboarding')) {
            return this._adaptDeliverySiteOnboardingRequest(action);
        } else if (authorization.action_request.name === 'Allowance Confirmation Request') {
            return this._adaptAllowanceConfirmationRequest(action);
        } else if (authorization.action_request.name === 'Judicial Management Request') {
            return this._adaptJudicialManagementRequest(authorization.action_request);
        }
    }

    _adaptJudicialManagementRequest(actionRequest) {
        const objectWithActionRequested = actionRequest.object_with_action_requested
        return {
            requestedStage: actionRequest.requested_stage,
            reason: actionRequest.reason,
            overdueInvoicesCount: actionRequest.overdue_invoices_count,
            overdueInvoicesTotalPendingBalance: actionRequest.overdue_invoices_total_pending_balance.amount,
            customer: {
                businessName: objectWithActionRequested.customer.business_name,
            },
        }
    }

    _adaptAllowanceConfirmationRequest(object_with_action_requested) {
        return {
            concept: object_with_action_requested.concept,
            subject: this._adaptAllowanceSubject(object_with_action_requested.subject),
            beneficiary: this._adaptAllowanceSubject(object_with_action_requested.beneficiary),
            subjectIsTheBeneficiary: object_with_action_requested.subject_is_the_beneficiary,
            validFrom: object_with_action_requested.valid_from,
            validTo: object_with_action_requested.valid_to,
            resolution: this._adaptAllowanceResolution(object_with_action_requested.resolution),
        }
    }

    _adaptAllowanceSubject(subject) {
        return {
            kind: subject.kind,
            businessName: subject.business_name,
        }
    }

    _adaptAllowanceResolution(resolution) {
        return {
            kind: resolution.kind,
            percentage: resolution.percentage,
            article: resolution.article ? {code: resolution.article.code, name: resolution.article.name} : null,
        }
    }

    _adaptAdvancePaymentRequest(object_with_action_requested) {
        return {
            number: object_with_action_requested.number,
            purchaseOrderNumber: object_with_action_requested.customers_order_number,
            state: object_with_action_requested.state,
            customer: {
                code: object_with_action_requested.customer.code,
                businessName: object_with_action_requested.customer.business_name,
                customerCode: object_with_action_requested.customer.code,
                fantasyName: object_with_action_requested.customer.fantasy_name,
            },
            deliverySite: {
                deliverySiteCode: object_with_action_requested.delivery_site.code,
                deliverySiteName: object_with_action_requested.delivery_site.name,
                deliverySiteAddress: object_with_action_requested.delivery_site.location.address,
                deliverySiteCity: object_with_action_requested.delivery_site.location.city,
                deliveryDate: "",
            },
            observations: object_with_action_requested.observations,
            deliveryDate: this._adaptDateOfApproval(object_with_action_requested.delivery_date),
            articles: this._adaptArticles(object_with_action_requested),
        }
    }

    _adaptFreeOrderConfirmationRequest(object_with_action_requested) {
        return {
            number: object_with_action_requested.number,
            purchaseOrderNumber: object_with_action_requested.customers_order_number,
            state: object_with_action_requested.state,
            customer: {
                code: object_with_action_requested.customer.code,
                businessName: object_with_action_requested.customer.business_name,
                customerCode: object_with_action_requested.customer.code,
                fantasyName: object_with_action_requested.customer.fantasy_name,
            },
            deliverySite: {
                deliverySiteCode: object_with_action_requested.delivery_site.code,
                deliverySiteName: object_with_action_requested.delivery_site.name,
                deliverySiteAddress: object_with_action_requested.delivery_site.location.address,
                deliverySiteCity: object_with_action_requested.delivery_site.location.city,
                deliveryDate: "",
            },
            observations: object_with_action_requested.observations,
            deliveryDate: this._adaptDateOfApproval(object_with_action_requested.delivery_date),
            articles: this._adaptArticles(object_with_action_requested),
        }
    }

    _adaptArticles(action) {
        const state = action.state;

        return action.articles.map(articleWithAmount => {
                const article = {
                    code: articleWithAmount.article.code,
                    name: articleWithAmount.article.name,
                    fantasyName: articleWithAmount.article.fantasy_name,
                    family: articleWithAmount.article.category.name,
                    amount: articleWithAmount.quantity,
                    discount: articleWithAmount.discount
                }
                if (state === 'INVOICED') {
                    article.fantasyName = articleWithAmount.article.fantasy_name
                    article.price = articleWithAmount.price
                    article.unitPrice = articleWithAmount.unit_price
                }
                return article
            }
        )
    }

    _adaptCustomerOnboardingRequest(object_with_action_requested) {
        return {
            taxpayerIdentificationNumber: object_with_action_requested.request.taxpayer_identification_number,
        }
    }

    _adaptDeliverySiteOnboardingRequest(object_with_action_requested) {
        return {
            deliverySiteOnboardingId: object_with_action_requested.id,
        }
    }
}